<template> 
<div class="rank-component">
  <img src="../../assets/img/pc/activity/rank_title.png"  class="title-img">

  <div v-if="(start==false) || (list.length == 0 && isload)" class="nothing">
       暂无排行榜数据！
       </div>
  <table v-else class="table-list" >
    <thead class="header">
      <tr class="title">
        <td></td>
        <td>用户名</td>
        <td>所属机构</td>
        <td>手机号</td>
        <td>阅读时长</td> 
      </tr>
    </thead>
    <tbody class="items">
       <!-- <tr>
        <td class="no"><span>1</span></td>
        <td class="name"><span>李四</span></td>
        <td class="jg"><span>中文在线</span></td>
        <td class="iphone"><span>186****0352</span></td>
        <td class="times">1小时0分8秒</td> 
      </tr> -->
       <tr v-for="(item, index) in list" :key="index">
        <td class="no"><span>{{ index + 1 }}</span></td>
        <td class="name"><span>{{ item.nick }}</span></td>
        <td class="jg"><span>{{item.appName}}</span></td>
        <td class="iphone" >
          <span v-if="(item.phone   && item.phone.length>0)" >{{ item.phone }}</span>
          <a v-else  target="_blank"  :ref="'addPhone'+index"  class="add-iphone" @click="updateIphoneNew(index,item.firstName)">点击填写手机号</a>
        </td>
       
        <td class="times">{{ changeTime(item.keepTime) }}</td> 
      </tr> 
    </tbody>
  </table>
  <p class="tips">(每小时刷新)</p>
</div>
   
 
</template>

<script>
import { getApp, getToken, getOrgRank } from "../../../../../common/js/service";
import { formateSeconds,formateDate } from "../../../../../common/js/tool";
export default {
  name: "ranka",
  data() {
    return {
      //bannerImg: require("../../assets/img/m/banner/banner.png"), 
      //wenziImg: require("../../assets/img/m/banner/title.png")
      rankType: 0,// 榜单类型，0：总榜，1：月榜，2：周榜
      isload: false, //是否请求数据
      list: [], //总榜排名名单
      list_month:[],//月榜排名名单
      list_week:[], //周榜排名名单
      hostName: "",
      appId: 0,
      appName:null,
      beginTime: "2024/04/17",
      endTime: "2024/4/30",
      page: 1,
      pageSize: 28,
      start:false,//活动是否开始
      end:false,//活动是否结束
      myDate:{
        total:{ //总时间段
          beginDate: null,
          endDate: null,
        },
        month:{//月时间段
          beginDate: null,
          endDate: null,
        },
        week:{//周时间段
          beginDate: null,
          endDate: null,
        }
      }
    };
  },
  created() {
    
     this.setMyDateTime();
     var beginDate =new Date(this.beginTime);
     // var endDate = new Date(this.endTime);
     var timenow = new Date();
      if(timenow<beginDate){
        this.start = false;
      }else {
        this.start = true;
      }
       
    if(this.start ){ //活动已经开始但还没有结束 
      this.infiniteHandler();
    }


  },
   methods: {
    changeType(typeValue){
      if(this.rankType == typeValue){
        return ;
      }else {
        this.rankType = typeValue;
      }
    },
    setMyDateTime(){
        //获取当前时间
        let  today=new Date();
        let aBeginDate = new Date(this.beginTime); //活动开始时间
        let aEndDate = new Date(this.endTime); //活动结束时间  
        this.myDate.total.beginDate =formateDate(aBeginDate);
        this.myDate.total.endDate = formateDate(aEndDate); 
    }, 
    changeTime(endTime) {
      return formateSeconds(endTime);
    },

    infiniteHandler() {
      let that = this;
      getApp()
        .then((res) => { 
          if (res.data) {
            let data1 = res.data;
            if (data1.success && data1.result && data1.result.app) { 
              that.appId = data1.result.app.id?  data1.result.app.id : 0;
              that.appName = data1.result.app.name; 
              // 获取总榜
              getToken(data1.result.app.atiak)
                .then((res2) => {
                  let data2 = res2.data;
                 // console.log("token data:",data2);
                  if (data2.success && data2.result.token) { 
                    // 总榜
                    if(that.myDate.total.beginDate && that.myDate.total.endDate){ 
                      getOrgRank(
                        data2.result.token,
                        that.page,
                        that.pageSize,
                        that.myDate.total.beginDate,
                        that.myDate.total.endDate,
                      )
                        .then((res3) => {
                          let data3 = res3.data;
                          //console.log("data3:",data3);
                          this.isload = true;
                          if (data3.success && data3.list) {
                            that.list = data3.list; 
                          }
                        })
                        .catch((error) => {
                          console.log("error3:", error);
                        }); 
                    }else {
                      this.list =[];
                    }

                    // if(that.myDate.month.beginDate && that.myDate.month.endDate){ 
                    //   // 月榜
                    //   getTotalRank(
                    //     data1.result.app.id,
                    //     data2.result.token,
                    //     that.page,
                    //     that.pageSize,
                    //     that.myDate.month.beginDate,
                    //     that.myDate.month.endDate,
                    //   )
                    //     .then((res3Month) => {
                    //       let data3 = res3Month.data;
                    //       //console.log("res3Month.data:",data3); 
                    //       if (data3.success && data3.list) {
                    //         that.list_month = data3.list;
                    //       }
                    //     })
                    //     .catch((error) => {
                    //       console.log("error3:", error);
                    //     });

                    // } else {
                    //   this.list_month = [];
                    // }
                   
                    // 周榜
                    // if(that.myDate.week.beginDate && that.myDate.week.endDate){
                    //   //console.log("2222222222222222222");
                    //   getTotalRank(
                    //     data1.result.app.id,
                    //     data2.result.token,
                    //     that.page,
                    //     that.pageSize,
                    //     that.myDate.week.beginDate,
                    //     that.myDate.week.endDate,
                    //   )
                    //     .then((res3Week) => {
                    //       let data3 = res3Week.data;
                    //       //console.log(" res3Week.data:",data3); 
                    //       if (data3.success && data3.list) {
                    //         that.list_week = data3.list;
                    //       }
                    //     })
                    //     .catch((error) => {
                    //       console.log(" res3Week.data error3:", error);
                    //     });
                    // }else {
                    //   this.list_week = [];
                    // }

                    this.isload = true;

                  } else {
                    console.log("获取资源失败");
                  }
                })
                .catch((error) => {
                  console.log("error2:", error);
                }); 

            }else {
              this.isload = true; //数据加载结束
            }
          }else {
            this.isload = true; //数据加载结束
          }
        })
        .catch((error) => {
          this.isload = true; //数据加载结束
          console.log("error1:", error);
        });
    },

    updateIphone(hostName){  //去修改手机号 
        if(hostName && hostName.length>0){
          top.location.href=window.location.protocol +'//'+hostName+'.chineseall.cn/user/info.jsps';
        }else {
          console.log("未获取到用户机构域名!");
        }
    },
     updateIphoneNew(index,hostName){  //去修改手机号 
        if(hostName && hostName.length>0){
          this.$refs[`addPhone${index}`][0].href=window.location.protocol +'//'+hostName+'.chineseall.cn/index';
          this.$refs[`addPhone${index}`][0].click();
        }else {
          console.log("未获取到用户机构域名!");
        }
    }
  },
  mounted() {},
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="scss" scoped>
 .rank-component{
  width: 100%;
  text-align: center; 
  position: relative;
 }
  .img-title{
    width: 7.47rem;
      height: 1.9rem;
      display: inline-block;
      margin: auto;
  }
  .rank-type-box{
    width: 100%;
    margin: 0.4rem 0 0.2rem;
    .tabs{
      width: 100%;
      display: flex;
      justify-content: center;
      align-items:center; 
      justify-items: flex-start;
      .item{
        width: 30%;
        text-align: center;
        font-size: 0.32rem;
        color: #666666;
        font-weight: 500;
        line-height: 1.5em;
        cursor: pointer;
        display: flex;
        flex-direction: column;
        align-items: center;
      }
      .item.selected{
        color: #F3625D; 
      }
      .item.selected::after{
        content: "";
        width: 0.24rem;
        height: 0.04rem;
        background-color: #F3625D;
        border-radius: 0.02rem;
        display: block;
      }
    }
    .dec{
      width: 98%;
      text-align: center;
      font-size: 0.24rem;
      color: #666;
      margin-top: 0.22rem;
    }
  }
  .rank {
    width: 100%;
    padding: 0.3rem;
    font-size: 0.2rem;
    color: #333333;
    display: flex;
    justify-content: space-between;
    flex-wrap: wrap;
    align-items: center;
    box-sizing: border-box;  
    
    .item {
      width: 100%;
      display: flex;
      align-items: center;
      justify-items: baseline;
      box-sizing: border-box;
      font-size: 0.24rem;
      color: #fff;
      border-bottom: 0.06rem solid #FFF3D4; 
      font-family: 'fangsong',Source Han Serif SC;
        font-weight: bold;
      .name,
      .iphone,
      .times{ 
      background-color: #BD3F07; 
      min-height: 0.72rem; 
      line-height: 0.72rem;
      display: inline-block;
      >em{
        width: 100%;
        height: 100%;
        line-height: 0.3rem;
      }
      }
      .no {
        width:10%;
        height: auto;
        line-height: 0.72rem;
        font-size: 0.36rem;
        text-align: left;
        background-color: #FF6F2F;
        border-right: 0.06rem solid #FFF3D4;
        display: inline-block;
        text-align: center;
      }
      .name {
        width: 30%;
        padding: 0 0.1rem;
        text-indent: 0;
        word-break: break-word;
      }
      .school-no{
        width: 22%;
        .bind-btn{
          width: auto;
          height: 0.4rem;
          line-height: 0.4rem;
          padding: 0 0.15rem;
          background-color: #F57E31;
          border-radius: 0.04rem;
          display: inline-block;
          color: #fff;
        }
      }
      .iphone {
        width: 26%;
        padding: 0 0.1rem;
      } 
      .times {
        width: 34%;
        text-align: right;
        padding-right: 0.1rem;
      }
    }

    .item.title {
      width: 100%;
      font-size: 0.24rem;
      font-weight: bold;
      color: #2A2A2A;
      line-height: 1.5em; 
      background-color: #FFF3D4;  
      display: flex;
      align-items: baseline;
      height: 0.6rem;
       .name,
      .iphone,
      .times{
      background-color: #FFF3D4; 
      min-height: 0.40rem;  
      display: inline-block;
      }
      .no {
        text-align: left;
      }
    }
     
  }
  .rank{
    >div{
      width: 100%;
    }
  }
  .table-list{
    width: 100%;
    margin-top: 1.2rem;
    .header{
      width: 100%;
      .title{
        width: 100%;
        min-height: 0.4rem; 
        font-size: 0.36rem;
        color: #2A2A2A;
        font-family: 'fangsong',Source Han Serif SC;
        font-weight: bold;
      }
    }
    .items{
      font-size: 0.28rem;
      color: #fff;
      >tr{
        background-color: #0E42C9;
        color: #fff;  
        min-height: 0.72rem;
        font-family: 'fangsong',Source Han Serif SC;
        font-weight: bold; 
        >td{
          border:none; 
          border-bottom: 0.05rem solid #FFF3D4;
          >span{
            padding: 0.13rem;
            line-height: 0.3rem;
            display: inline-block;
          }
        }
        .no{
          font-size: 0.36rem;
          width: 10%;
          background-color: #0E42C9;
          border-right: 0.05rem solid #FFF3D4;
        }
        .name{
          width: 20%;
          border-right: 0; 
        }
        .iphone{
          width: 25%;
          border-right: 0; 
        }
        .times{
          width: 25%;
          border-right: 0; 
        }
        .jg{
          width: 20%;
        }
      }
    }
  }
   table,td,tr,th{
        border-style:none;
    }
    table {
        border-collapse: collapse;
    }
    .nothing{
      width: 100%;
      padding: 0.5rem 0;
      position: relative;
      margin-top: 0.6rem;
    }
    .tips{
      width: 100%;
      margin-top: 0.1rem;
      text-align: center;
      font-size: 0.24rem;
      color: #333333;
      font-weight: bold;
      font-family: 'fangsong',Source Han Serif SC;
    }

     .add-iphone{
      //font-size: 0.2rem;
      //color: blue;
      width: auto;
      cursor: pointer;
      text-decoration:underline;
      font-style:oblique;
      color: #fff;
    }
</style>
